<template>
    <div class="card">
        <header>
            <span class="icon material-icons">
                {{ type }}
            </span>
        </header>
        <div class="text_area">
            <h4>{{ sectionName }}</h4>
            <p>{{ description }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ["type", "sectionName", "description"]
}
</script>

<style scoped>
.card {
    border: 1.5px solid var(--sniffer-color-border);
    width: 46%;
    height: 11rem;
    display: flex;
}

.card:hover {
    box-shadow: 1.5px 1.5px 1.5px 1.5px rgba(0, 0, 0, 0.2);
    cursor: pointer;
}

header {
    background-color: var(--sniffer-color-light-blue);
    min-width: 8rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

header span {
    color: var(--sniffer-color-primary);
    font-size: 90px;
}

.text_area {
    padding: 12px 18px;
}
</style>